import React, { useState, useEffect, useCallback } from "react";
import { Loading } from "../../components/shared";

const BookViewerPWA = ({ config }) => {
  const { title, index: localIndex, bucketIndexUrl, patternMode, patternUrl, totalPages } = config;

  const [index, setIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingIndex, setLoadingIndex] = useState(true);
  const [error, setError] = useState(null);

  // 👇 new state to track image loading
  const [imageLoading, setImageLoading] = useState(true);

  // Load index.json or build it depending on config
  useEffect(() => {
    let canceled = false;

    async function loadIndex() {
      setLoadingIndex(true);
      setError(null);

      try {
        if (localIndex) {
          if (!canceled) setIndex(localIndex);
        } else if (patternMode) {
          const pages = [];
          const width = String(totalPages).length;

          for (let i = 1; i <= totalPages; i++) {
            const num = String(i).padStart(width, "0");
            const src = patternUrl.replace("{num}", num).replace("{page}", i);
            pages.push({ page: i, src, title: `Page ${i}` });
          }
          if (!canceled) setIndex({ pages });
        } else if (bucketIndexUrl) {
          const resp = await fetch(bucketIndexUrl, { cache: "no-cache" });
          if (!resp.ok) throw new Error(`Failed to fetch index.json: ${resp.status}`);
          const data = await resp.json();
          if (!data.pages || !Array.isArray(data.pages)) throw new Error("index.json missing pages array");
          if (!canceled) setIndex(data);
        }
      } catch (err) {
        console.error(err);
        if (!canceled) setError(err.message || String(err));
      } finally {
        if (!canceled) setLoadingIndex(false);
      }
    }

    loadIndex();
    return () => {
      canceled = true;
    };
  }, [config]);

  const goToPage = useCallback((pageNum) => {
    if (index && index.pages) {
      if (pageNum >= 1 && pageNum <= index.pages.length) {
        setCurrentPage(pageNum);
        setImageLoading(true); // 👈 reset spinner when switching pages
      }
    }
  }, [index]);

  if (loadingIndex) return <div>Loading index…</div>;
  if (error) return <div style={{ color: "red" }}>Error: {error}</div>;
  if (!index || !index.pages || index.pages.length === 0) return <div>No pages found</div>;

  const current = index.pages[currentPage - 1];

  return (
    <div className="book-viewer">
      <h2>{title}</h2>
      <br />
      <div className="auth_element">
        <select
          value={currentPage}
          onChange={(e) => goToPage(Number(e.target.value))}
          className="auth_select"
        >
          {index.pages
            .filter((p) => p.title && p.title.trim() !== "")
            .map((p) => (
              <option key={p.page} value={p.page}>
                {p.title}
              </option>
            ))}
        </select>
      </div>

      <div className="pagination-controls">
        <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage <= 1}>
          முந்தைய பக்கம்
        </button>
        <span>
          பக்கம் {currentPage} / {index.pages.length}
        </span>
        <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage >= index.pages.length}>
          அடுத்த பக்கம்
        </button>
      </div>

      <div className="page-view" style={{ position: "relative", minHeight: "300px" }}>
        {imageLoading && (
          <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <Loading />
          </div>
        )}
        {current ? (
          <img
            src={current.src}
            alt={current.title || `Page ${current.page}`}
            style={{ maxWidth: "100%", height: "auto", display: imageLoading ? "none" : "block" }}
            onLoad={() => setImageLoading(false)} // 👈 hide spinner when loaded
            onError={() => setImageLoading(false)} // fallback: stop spinner on error
          />
        ) : (
          <div>Page not found</div>
        )}
      </div>

      <div className="pagination-controls">
        <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage <= 1}>
          முந்தைய பக்கம்
        </button>
        <span>
          பக்கம் {currentPage} / {index.pages.length}
        </span>
        <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage >= index.pages.length}>
          அடுத்த பக்கம்
        </button>
      </div>
    </div>
  );
};

export default BookViewerPWA;
